import PropTypes from 'prop-types';
import InputField from './InputField';

const AuthCard = ({ mode, formValues, onChange, onSubmit, toggleMode, disabled, error }) => {
  const isRegister = mode === 'register';

  return (
    <div className="auth-card">
      <div className="auth-card__header">
        <h1>Modskill Image Lab</h1>
        <p>Sign in with your login to access the generator dashboard.</p>
      </div>

      {error && <div className="auth-card__error">{error}</div>}

      <form onSubmit={onSubmit}>
        <InputField
          label="Login"
          name="login"
          autoComplete="username"
          value={formValues.login}
          onChange={onChange}
          required
          disabled={disabled}
        />

        {isRegister && (
          <InputField
            label="Display name"
            name="displayName"
            value={formValues.displayName}
            onChange={onChange}
            placeholder="e.g. ArtCreator"
            disabled={disabled}
          />
        )}

        <InputField
          label="Password"
          name="password"
          type="password"
          autoComplete={isRegister ? 'new-password' : 'current-password'}
          value={formValues.password}
          onChange={onChange}
          required
          disabled={disabled}
        />

        <button type="submit" className="auth-card__submit" disabled={disabled}>
          {disabled ? 'Loading...' : isRegister ? 'Create account' : 'Sign in'}
        </button>
      </form>

      <p className="auth-card__toggle">
        {isRegister ? 'Already have an account?' : 'New to the project?'}{' '}
        <button type="button" onClick={toggleMode} disabled={disabled}>
          {isRegister ? 'Sign in' : 'Create account'}
        </button>
      </p>
    </div>
  );
};

AuthCard.propTypes = {
  mode: PropTypes.oneOf(['login', 'register']).isRequired,
  formValues: PropTypes.shape({
    login: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    displayName: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  toggleMode: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

AuthCard.defaultProps = {
  disabled: false,
  error: null,
};

export default AuthCard;
